// CrossLinkBanner — banner de salto cruzado Kits↔Tienda (mismo markup, acento invertido).
// Fuente: maquetas (kits.html → Tienda con acento gold; catalogo.html → Kits con acento teal).
//
// Self-contained: <style>{XL_CSS}</style> + clases .tv5-xl-* + tokens --tv5-* propios.
//
// Props:
//   title     string   → título (ej. "¿Preferís sin compromiso?")
//   sub       string   → subtítulo
//   ctaLabel  string   → texto del botón (ej. "Ir a la Tienda →")
//   ctaHref   string   → destino del botón (ruta interna)
//   accent    'teal'|'gold'  → color del acento (default 'teal')
import { Link } from 'react-router-dom';

const XL_CSS = `
.tv5-xl {
  --tv5-teal:#00A8B5; --tv5-gold:#C5A059; --tv5-navy:#1A3461;
  --tv5-muted:rgba(248,246,241,0.65); --tv5-border:rgba(255,255,255,0.08);
  --tv5-acc:var(--tv5-teal); --tv5-acc-rgb:0,168,181;
  max-width:1200px; margin:40px auto 0; padding:24px 20px;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.tv5-xl--gold { --tv5-acc:var(--tv5-gold); --tv5-acc-rgb:197,160,89; }
.tv5-xl-card {
  background:linear-gradient(135deg, rgba(var(--tv5-acc-rgb),0.12) 0%, rgba(var(--tv5-acc-rgb),0.04) 100%);
  border:1px solid rgba(var(--tv5-acc-rgb),0.3); border-radius:20px; padding:24px;
  display:flex; align-items:center; justify-content:space-between; gap:20px; flex-wrap:wrap;
}
.tv5-xl-text { flex:1 1 auto; min-width:200px; }
.tv5-xl-title { font-size:20px; font-weight:800; letter-spacing:-0.01em; margin-bottom:4px; color:var(--tv5-acc); }
.tv5-xl-sub { font-size:13px; color:var(--tv5-muted); line-height:1.5; }
.tv5-xl-btn {
  background:var(--tv5-acc); color:var(--tv5-navy); padding:12px 24px; border-radius:10px;
  font-weight:800; font-size:13px; text-decoration:none; white-space:nowrap;
  min-height:44px; display:inline-flex; align-items:center; transition:transform 0.2s;
}
@media (hover:hover){ .tv5-xl-btn:hover { transform:translateX(4px); } }
`;

export function CrossLinkBanner({ title, sub, ctaLabel, ctaHref, accent = 'teal' }) {
  return (
    <div className={'tv5-xl' + (accent === 'gold' ? ' tv5-xl--gold' : '')}>
      <style>{XL_CSS}</style>
      <div className="tv5-xl-card">
        <div className="tv5-xl-text">
          <div className="tv5-xl-title">{title}</div>
          <div className="tv5-xl-sub">{sub}</div>
        </div>
        <Link to={ctaHref} className="tv5-xl-btn">{ctaLabel}</Link>
      </div>
    </div>
  );
}
